import React from "react"

import { MinusIcon } from "@/components/icons/MinusIcon"
import { PlusIcon } from "@/components/icons/PlusIcon"

interface SchoolCounterProps {
  value: number
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onIncrement: () => void
  onDecrement: () => void
  minValue?: number
}

export function SchoolCounter({
  value,
  onChange,
  onIncrement,
  onDecrement,
  minValue = 2,
}: SchoolCounterProps) {
  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-my-6 tw-p-3 tw-bg-gray-100">
      <span className="tw-text-sm tw-font-medium tw-text-gray-700 tw-mr-3">
        Quote for
      </span>
      <div className="tw-flex tw-items-center tw-bg-white tw-rounded-md tw-border tw-border-gray-200 tw-overflow-hidden">
        <button
          className="tw-px-2 tw-py-1 tw-text-green-600 tw-hover:bg-green-50 tw-transition-colors"
          onClick={onDecrement}
          aria-label="Decrease number of schools"
          disabled={value <= minValue}
        >
          <MinusIcon />
        </button>
        <input
          value={value}
          onChange={onChange}
          type="number"
          min={minValue}
          step="1"
          className="tw-w-12 tw-text-sm tw-text-center tw-border-0 tw-focus:ring-0 tw-outline-none"
          aria-label="enter the number of schools in your district"
        />
        <button
          className="tw-px-2 tw-py-1 tw-text-green-600 tw-hover:bg-green-50 tw-transition-colors"
          onClick={onIncrement}
          aria-label="Increase number of schools"
        >
          <PlusIcon />
        </button>
      </div>
      <span className="tw-text-sm tw-font-medium tw-text-gray-700 tw-ml-3">
        schools
      </span>
    </div>
  )
}
